import styled from 'styled-components';
import { Button } from '../Button/Button.js';
export { defaultProps } from '../Button/Button.js';
import { LinkButtonStyle } from './LinkButton.styles.js';

// Implementation note:
// Typings of Styled components `as` property are currently broken, if the
// property is used within JSX markup:
// https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/53819#discussion-3410809
// However, there is a workaround usings `.attrs()`:
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35143
const LinkButton = styled(Button).attrs(({ children }) => {
    // Explicit type annotation is required here to tell TypeScript with
    // @types/react version 18 that the external type interface of the
    // `children` property doesn't change although the Button component injects
    // the `icon` to the `children` property under the hood.
    const modifiedProps = {
        children,
    };
    return {
        as: 'a',
        ...modifiedProps,
    };
}) `
    ${LinkButtonStyle}
`;

export { LinkButton };
//# sourceMappingURL=LinkButton.js.map
